"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentOverrideConfig = void 0;
exports.ComponentOverrideConfig = {
    MuiSwitch: {
        styleOverrides: {
            root: {
                width: '2.25rem',
                height: '1.25rem',
                color: '#CED0D7',
                borderColor: '#CED0D7',
                padding: 0,
                display: 'flex',
                marginRight: '0.5rem',
            },
            switchBase: {
                padding: '0.125rem',
                color: '#CED0D7',
                borderColor: '#CED0D7',
                '&.Mui-checked': {
                    transform: 'translateX(16px)',
                    color: '#FFFFFF',
                    '&.Mui-checked+.MuiSwitch-track': {
                        opacity: 1,
                        backgroundColor: '#4467C9',
                        borderColor: '#4467C9',
                    },
                },
            },
            thumb: {
                width: '1rem',
                height: '1rem',
                boxShadow: 'none',
                color: '#FFFFFF',
            },
            track: {
                border: `0.0625rem solid #CED0D7`,
                borderRadius: '0.625rem',
                opacity: 1,
                backgroundColor: '#CED0D7',
                borderColor: '#CED0D7',
            },
        },
    },
    MuiTextField: {
        styleOverrides: {
            root: {
                '& .MuiFormHelperText-root': {
                    fontSize: '0.75rem',
                    fontWeight: 400,
                },
            },
        },
    },
    MuiFilledInput: {
        styleOverrides: {
            root: {
                height: 'auto',
                minHeight: '3.5rem',
                borderRadius: '0.125rem',
                backgroundColor: '#FAFAFA',
                '&.Mui-focused': {
                    backgroundColor: '#F0F4FF',
                    color: '#4467C9',
                },
                '&.Mui-error': {
                    '&:not(.Mui-focused)': {
                        backgroundColor: '#FFFFFF',
                    },
                    backgroundColor: '#FFEEEE',
                    color: '#EB4747',
                },
                '&:hover': {
                    backgroundColor: '#FAFAFA',
                },
                '&:hover:not(.Mui-disabled):before': {
                    borderBottom: '0.125rem solid',
                    borderBottomColor: '#6C7388',
                    borderRadius: '0 0 0.25rem 0.25rem',
                },
                '&.Mui-disabled': {
                    backgroundColor: '#F3F3F5',
                },
            },
            underline: {
                '&:before': {
                    borderBottom: '0.125rem solid',
                    borderBottomColor: '#CED0D7',
                    borderRadius: '0 0 0.25rem 0.25rem',
                },
                '&:hover:before': {
                    borderBottom: '0.125rem solid',
                    borderBottomColor: '#6C7388',
                    borderRadius: '0 0 0.25rem 0.25rem',
                },
                '&.Mui-focused:not(.Mui-error)': {
                    '&:hover:before': {
                        borderBottomColor: '#4467C9',
                    },
                    '&:before': {
                        borderBottomColor: '#4467C9',
                    },
                },
                '&.Mui-error': {
                    '&:hover:before': {
                        borderBottomColor: '#EB4747',
                    },
                    '&:before': {
                        borderBottomColor: '#EB4747',
                    },
                },
                '&.Mui-disabled': {
                    '&:hover:before': {
                        borderBottomStyle: 'solid',
                        borderBottomColor: '#CED0D7',
                    },
                    '&:before': {
                        borderBottomStyle: 'solid',
                        borderBottomColor: '#CED0D7',
                    },
                },
                '&:after': {
                    borderBottom: 0,
                },
            },
            input: {
                fontWeight: 'normal',
            },
        },
    },
    MuiSelect: {
        styleOverrides: {
            filled: {
                '&.Mui-focused': {
                    backgroundColor: '#F0F4FF',
                },
            },
            icon: {
                color: '#CED0D7',
            },
        },
    },
    MuiButton: {
        styleOverrides: {
            root: {
                textTransform: 'none',
                height: '2.5rem',
                fontSize: '0.75rem',
                fontWeight: 600,
            },
            containedPrimary: {
                '&:hover': { backgroundColor: '#688EFC' },
                '&:active': { backgroundColor: '#284496' },
            },
            sizeLarge: {
                height: '3.5rem',
                fontSize: '0.875rem',
                fontWeight: 600,
            },
            sizeSmall: {
                height: '1.5rem',
                fontSize: '0.75rem',
                fontWeight: 600,
            },
        },
    },
    MuiCheckbox: {
        styleOverrides: {
            root: {
                color: '#CED0D7',
                borderRadius: '0.25rem',
                '&.MuiIconButton-colorSecondary:hover': {
                    backgroundColor: 'rgba(68, 103, 201, 0.04)',
                },
                '&.MuiCheckbox-colorSecondary.Mui-checked:hover': {
                    backgroundColor: 'rgba(68, 103, 201, 0.04)',
                },
            },
            colorSecondary: {
                '&.Mui-checked': {
                    color: '#4467C9',
                },
            },
        },
    },
    MuiTablePagination: {
        styleOverrides: {
            root: {
                color: '#3C4560',
            },
            select: {
                backgroundColor: '#FAFAFA',
                borderRadius: '0.125rem',
                height: '1.25rem',
                lineHeight: '1.25rem',
                borderBottom: '0.125rem solid #CED0D7',
                '&:focus': {
                    backgroundColor: '#FAFAFA',
                },
            },
        },
    },
    MuiToggleButton: {
        styleOverrides: {
            root: {
                color: '#4467C9',
                textTransform: 'capitalize',
                '&.Mui-selected': {
                    backgroundColor: '#4467C9',
                    color: '#FFFFFF',
                    '&:hover': {
                        backgroundColor: '#688EFC',
                    },
                },
            },
        },
    },
    MuiPickersDay: {
        styleOverrides: {
            root: {
                borderRadius: 0,
            },
        },
    },
    MuiIconButton: {
        styleOverrides: {
            root: {
                color: 'inherit',
            },
        },
    },
    MuiAlert: {
        styleOverrides: {
            root: {
                padding: '0 1rem',
                textTransform: 'none',
                backgroundColor: '#F3F3F5',
            },
            standardSuccess: {
                backgroundColor: '#E9FFFB',
                color: '#3C4560',
                '& .MuiAlert-icon': {
                    color: '#3C4560',
                },
            },
            standardInfo: {
                backgroundColor: '#F3F3F5',
                color: '#3C4560',
                '& .MuiAlert-icon': {
                    color: '#3C4560',
                },
            },
            standardWarning: {
                backgroundColor: '#FFFCEE',
                color: '#3C4560',
                '& .MuiAlert-icon': {
                    color: '#3C4560',
                },
            },
            standardError: {
                backgroundColor: '#FFEEEE',
                color: '#3C4560',
                '& .MuiAlert-icon': {
                    color: '#3C4560',
                },
            },
        },
    },
    MuiChip: {
        styleOverrides: {
            root: {
                color: '#3C4560',
            },
        },
    },
    MuiLinearProgress: {
        styleOverrides: {
            root: {
                backgroundColor: '#F3F3F5',
                height: '0.5rem',
                borderRadius: '1rem',
            },
        },
    },
    MuiInputBase: {
        styleOverrides: {
            input: {
                fontFamily: 'Source Sans Pro',
            },
        },
    },
    MuiTooltip: {
        styleOverrides: {
            tooltip: {
                backgroundColor: '#0B1638',
                fontWeight: 400,
                color: '#ffffff',
                fontSize: '0.75rem',
                borderRadius: '0.3rem',
                padding: `0.25rem 0.313rem 0.313rem 0.25rem`,
            },
            arrow: {
                color: '#0B1638',
            },
        },
    },
    MuiStepIcon: {
        styleOverrides: {
            root: {
                color: '#F3F3F5',
                '&.Mui-active': {
                    '& .MuiStepIcon-text': {
                        fill: '#FFFFFF',
                    },
                },
            },
            text: {
                fill: '#CED0D7',
            },
        },
    },
    MuiStepLabel: {
        styleOverrides: {
            label: {
                color: '#6C7388',
            },
            iconContainer: {
                '& .MuiSvgIcon-root': {
                    width: '2rem',
                    height: '2rem',
                },
            },
            labelContainer: {
                '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel': {
                    marginTop: 0,
                },
            },
        },
    },
    MuiStepButton: {
        styleOverrides: {
            root: {
                padding: '1rem 1rem',
            },
        },
    },
    MuiStepConnector: {
        styleOverrides: {
            alternativeLabel: {
                top: '1rem',
                left: 'calc(-50% + 2.5rem)',
                right: 'calc(50% + 2.5rem)',
                position: 'absolute',
            },
            lineHorizontal: {
                borderTopStyle: 'dashed',
                borderTopWidth: '0.125rem',
            },
            line: {
                borderColor: '#F3F3F5',
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50LW92ZXJyaWRlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb25zdGFudHMvdGhlbWUvY29tcG9uZW50LW92ZXJyaWRlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFVYSxRQUFBLHVCQUF1QixHQUFlO0lBQ2pELFNBQVMsRUFBRTtRQUNULGNBQWMsRUFBRTtZQUNkLElBQUksRUFBRTtnQkFDSixLQUFLLEVBQUUsU0FBUztnQkFDaEIsTUFBTSxFQUFFLFNBQVM7Z0JBQ2pCLEtBQUssRUFBRSxTQUFTO2dCQUNoQixXQUFXLEVBQUUsU0FBUztnQkFDdEIsT0FBTyxFQUFFLENBQUM7Z0JBQ1YsT0FBTyxFQUFFLE1BQU07Z0JBQ2YsV0FBVyxFQUFFLFFBQVE7YUFDdEI7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsT0FBTyxFQUFFLFVBQVU7Z0JBQ25CLEtBQUssRUFBRSxTQUFTO2dCQUNoQixXQUFXLEVBQUUsU0FBUztnQkFDdEIsZUFBZSxFQUFFO29CQUNmLFNBQVMsRUFBRSxrQkFBa0I7b0JBQzdCLEtBQUssRUFBRSxTQUFTO29CQUNoQixnQ0FBZ0MsRUFBRTt3QkFDaEMsT0FBTyxFQUFFLENBQUM7d0JBQ1YsZUFBZSxFQUFFLFNBQVM7d0JBQzFCLFdBQVcsRUFBRSxTQUFTO3FCQUN2QjtpQkFDRjthQUNGO1lBQ0QsS0FBSyxFQUFFO2dCQUNMLEtBQUssRUFBRSxNQUFNO2dCQUNiLE1BQU0sRUFBRSxNQUFNO2dCQUNkLFNBQVMsRUFBRSxNQUFNO2dCQUNqQixLQUFLLEVBQUUsU0FBUzthQUNqQjtZQUNELEtBQUssRUFBRTtnQkFDTCxNQUFNLEVBQUUseUJBQXlCO2dCQUNqQyxZQUFZLEVBQUUsVUFBVTtnQkFDeEIsT0FBTyxFQUFFLENBQUM7Z0JBQ1YsZUFBZSxFQUFFLFNBQVM7Z0JBQzFCLFdBQVcsRUFBRSxTQUFTO2FBQ3ZCO1NBQ0Y7S0FDRjtJQUNELFlBQVksRUFBRTtRQUNaLGNBQWMsRUFBRTtZQUNkLElBQUksRUFBRTtnQkFDSiwyQkFBMkIsRUFBRTtvQkFDM0IsUUFBUSxFQUFFLFNBQVM7b0JBQ25CLFVBQVUsRUFBRSxHQUFHO2lCQUNoQjthQUNGO1NBQ0Y7S0FDRjtJQUNELGNBQWMsRUFBRTtRQUNkLGNBQWMsRUFBRTtZQUNkLElBQUksRUFBRTtnQkFDSixNQUFNLEVBQUUsTUFBTTtnQkFDZCxTQUFTLEVBQUUsUUFBUTtnQkFDbkIsWUFBWSxFQUFFLFVBQVU7Z0JBQ3hCLGVBQWUsRUFBRSxTQUFTO2dCQUMxQixlQUFlLEVBQUU7b0JBQ2YsZUFBZSxFQUFFLFNBQVM7b0JBQzFCLEtBQUssRUFBRSxTQUFTO2lCQUNqQjtnQkFDRCxhQUFhLEVBQUU7b0JBQ2IscUJBQXFCLEVBQUU7d0JBQ3JCLGVBQWUsRUFBRSxTQUFTO3FCQUMzQjtvQkFDRCxlQUFlLEVBQUUsU0FBUztvQkFDMUIsS0FBSyxFQUFFLFNBQVM7aUJBQ2pCO2dCQUNELFNBQVMsRUFBRTtvQkFDVCxlQUFlLEVBQUUsU0FBUztpQkFDM0I7Z0JBQ0QsbUNBQW1DLEVBQUU7b0JBQ25DLFlBQVksRUFBRSxnQkFBZ0I7b0JBQzlCLGlCQUFpQixFQUFFLFNBQVM7b0JBQzVCLFlBQVksRUFBRSxxQkFBcUI7aUJBQ3BDO2dCQUNELGdCQUFnQixFQUFFO29CQUNoQixlQUFlLEVBQUUsU0FBUztpQkFDM0I7YUFDRjtZQUNELFNBQVMsRUFBRTtnQkFDVCxVQUFVLEVBQUU7b0JBQ1YsWUFBWSxFQUFFLGdCQUFnQjtvQkFDOUIsaUJBQWlCLEVBQUUsU0FBUztvQkFDNUIsWUFBWSxFQUFFLHFCQUFxQjtpQkFDcEM7Z0JBQ0QsZ0JBQWdCLEVBQUU7b0JBQ2hCLFlBQVksRUFBRSxnQkFBZ0I7b0JBQzlCLGlCQUFpQixFQUFFLFNBQVM7b0JBQzVCLFlBQVksRUFBRSxxQkFBcUI7aUJBQ3BDO2dCQUNELCtCQUErQixFQUFFO29CQUMvQixnQkFBZ0IsRUFBRTt3QkFDaEIsaUJBQWlCLEVBQUUsU0FBUztxQkFDN0I7b0JBQ0QsVUFBVSxFQUFFO3dCQUNWLGlCQUFpQixFQUFFLFNBQVM7cUJBQzdCO2lCQUNGO2dCQUNELGFBQWEsRUFBRTtvQkFDYixnQkFBZ0IsRUFBRTt3QkFDaEIsaUJBQWlCLEVBQUUsU0FBUztxQkFDN0I7b0JBQ0QsVUFBVSxFQUFFO3dCQUNWLGlCQUFpQixFQUFFLFNBQVM7cUJBQzdCO2lCQUNGO2dCQUNELGdCQUFnQixFQUFFO29CQUNoQixnQkFBZ0IsRUFBRTt3QkFDaEIsaUJBQWlCLEVBQUUsT0FBTzt3QkFDMUIsaUJBQWlCLEVBQUUsU0FBUztxQkFDN0I7b0JBQ0QsVUFBVSxFQUFFO3dCQUNWLGlCQUFpQixFQUFFLE9BQU87d0JBQzFCLGlCQUFpQixFQUFFLFNBQVM7cUJBQzdCO2lCQUNGO2dCQUNELFNBQVMsRUFBRTtvQkFDVCxZQUFZLEVBQUUsQ0FBQztpQkFDaEI7YUFDRjtZQUNELEtBQUssRUFBRTtnQkFDTCxVQUFVLEVBQUUsUUFBUTthQUNyQjtTQUNGO0tBQ0Y7SUFDRCxTQUFTLEVBQUU7UUFDVCxjQUFjLEVBQUU7WUFDZCxNQUFNLEVBQUU7Z0JBQ04sZUFBZSxFQUFFO29CQUNmLGVBQWUsRUFBRSxTQUFTO2lCQUMzQjthQUNGO1lBQ0QsSUFBSSxFQUFFO2dCQUNKLEtBQUssRUFBRSxTQUFTO2FBQ2pCO1NBQ0Y7S0FDRjtJQUNELFNBQVMsRUFBRTtRQUNULGNBQWMsRUFBRTtZQUNkLElBQUksRUFBRTtnQkFDSixhQUFhLEVBQUUsTUFBTTtnQkFDckIsTUFBTSxFQUFFLFFBQVE7Z0JBQ2hCLFFBQVEsRUFBRSxTQUFTO2dCQUNuQixVQUFVLEVBQUUsR0FBRzthQUNoQjtZQUNELGdCQUFnQixFQUFFO2dCQUNoQixTQUFTLEVBQUUsRUFBRSxlQUFlLEVBQUUsU0FBUyxFQUFFO2dCQUN6QyxVQUFVLEVBQUUsRUFBRSxlQUFlLEVBQUUsU0FBUyxFQUFFO2FBQzNDO1lBQ0QsU0FBUyxFQUFFO2dCQUNULE1BQU0sRUFBRSxRQUFRO2dCQUNoQixRQUFRLEVBQUUsVUFBVTtnQkFDcEIsVUFBVSxFQUFFLEdBQUc7YUFDaEI7WUFDRCxTQUFTLEVBQUU7Z0JBQ1QsTUFBTSxFQUFFLFFBQVE7Z0JBQ2hCLFFBQVEsRUFBRSxTQUFTO2dCQUNuQixVQUFVLEVBQUUsR0FBRzthQUNoQjtTQUNGO0tBQ0Y7SUFDRCxXQUFXLEVBQUU7UUFDWCxjQUFjLEVBQUU7WUFDZCxJQUFJLEVBQUU7Z0JBQ0osS0FBSyxFQUFFLFNBQVM7Z0JBQ2hCLFlBQVksRUFBRSxTQUFTO2dCQUN2QixzQ0FBc0MsRUFBRTtvQkFDdEMsZUFBZSxFQUFFLDBCQUEwQjtpQkFDNUM7Z0JBQ0QsZ0RBQWdELEVBQUU7b0JBQ2hELGVBQWUsRUFBRSwwQkFBMEI7aUJBQzVDO2FBQ0Y7WUFDRCxjQUFjLEVBQUU7Z0JBQ2QsZUFBZSxFQUFFO29CQUNmLEtBQUssRUFBRSxTQUFTO2lCQUNqQjthQUNGO1NBQ0Y7S0FDRjtJQUNELGtCQUFrQixFQUFFO1FBQ2xCLGNBQWMsRUFBRTtZQUNkLElBQUksRUFBRTtnQkFDSixLQUFLLEVBQUUsU0FBUzthQUNqQjtZQUNELE1BQU0sRUFBRTtnQkFDTixlQUFlLEVBQUUsU0FBUztnQkFDMUIsWUFBWSxFQUFFLFVBQVU7Z0JBQ3hCLE1BQU0sRUFBRSxTQUFTO2dCQUNqQixVQUFVLEVBQUUsU0FBUztnQkFDckIsWUFBWSxFQUFFLHdCQUF3QjtnQkFDdEMsU0FBUyxFQUFFO29CQUNULGVBQWUsRUFBRSxTQUFTO2lCQUMzQjthQUNGO1NBQ0Y7S0FDRjtJQUNELGVBQWUsRUFBRTtRQUNmLGNBQWMsRUFBRTtZQUNkLElBQUksRUFBRTtnQkFDSixLQUFLLEVBQUUsU0FBUztnQkFDaEIsYUFBYSxFQUFFLFlBQVk7Z0JBQzNCLGdCQUFnQixFQUFFO29CQUNoQixlQUFlLEVBQUUsU0FBUztvQkFDMUIsS0FBSyxFQUFFLFNBQVM7b0JBQ2hCLFNBQVMsRUFBRTt3QkFDVCxlQUFlLEVBQUUsU0FBUztxQkFDM0I7aUJBQ0Y7YUFDRjtTQUNGO0tBQ0Y7SUFDRCxhQUFhLEVBQUU7UUFDYixjQUFjLEVBQUU7WUFDZCxJQUFJLEVBQUU7Z0JBQ0osWUFBWSxFQUFFLENBQUM7YUFDaEI7U0FDRjtLQUNGO0lBQ0QsYUFBYSxFQUFFO1FBQ2IsY0FBYyxFQUFFO1lBQ2QsSUFBSSxFQUFFO2dCQUNKLEtBQUssRUFBRSxTQUFTO2FBQ2pCO1NBQ0Y7S0FDRjtJQUNELFFBQVEsRUFBRTtRQUNSLGNBQWMsRUFBRTtZQUNkLElBQUksRUFBRTtnQkFDSixPQUFPLEVBQUUsUUFBUTtnQkFDakIsYUFBYSxFQUFFLE1BQU07Z0JBQ3JCLGVBQWUsRUFBRSxTQUFTO2FBQzNCO1lBQ0QsZUFBZSxFQUFFO2dCQUNmLGVBQWUsRUFBRSxTQUFTO2dCQUMxQixLQUFLLEVBQUUsU0FBUztnQkFDaEIsa0JBQWtCLEVBQUU7b0JBQ2xCLEtBQUssRUFBRSxTQUFTO2lCQUNqQjthQUNGO1lBQ0QsWUFBWSxFQUFFO2dCQUNaLGVBQWUsRUFBRSxTQUFTO2dCQUMxQixLQUFLLEVBQUUsU0FBUztnQkFDaEIsa0JBQWtCLEVBQUU7b0JBQ2xCLEtBQUssRUFBRSxTQUFTO2lCQUNqQjthQUNGO1lBQ0QsZUFBZSxFQUFFO2dCQUNmLGVBQWUsRUFBRSxTQUFTO2dCQUMxQixLQUFLLEVBQUUsU0FBUztnQkFDaEIsa0JBQWtCLEVBQUU7b0JBQ2xCLEtBQUssRUFBRSxTQUFTO2lCQUNqQjthQUNGO1lBQ0QsYUFBYSxFQUFFO2dCQUNiLGVBQWUsRUFBRSxTQUFTO2dCQUMxQixLQUFLLEVBQUUsU0FBUztnQkFDaEIsa0JBQWtCLEVBQUU7b0JBQ2xCLEtBQUssRUFBRSxTQUFTO2lCQUNqQjthQUNGO1NBQ0Y7S0FDRjtJQUNELE9BQU8sRUFBRTtRQUNQLGNBQWMsRUFBRTtZQUNkLElBQUksRUFBRTtnQkFDSixLQUFLLEVBQUUsU0FBUzthQUNqQjtTQUNGO0tBQ0Y7SUFDRCxpQkFBaUIsRUFBRTtRQUNqQixjQUFjLEVBQUU7WUFDZCxJQUFJLEVBQUU7Z0JBQ0osZUFBZSxFQUFFLFNBQVM7Z0JBQzFCLE1BQU0sRUFBRSxRQUFRO2dCQUNoQixZQUFZLEVBQUUsTUFBTTthQUNyQjtTQUNGO0tBQ0Y7SUFDRCxZQUFZLEVBQUU7UUFDWixjQUFjLEVBQUU7WUFDZCxLQUFLLEVBQUU7Z0JBQ0wsVUFBVSxFQUFFLGlCQUFpQjthQUM5QjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixjQUFjLEVBQUU7WUFDZCxPQUFPLEVBQUU7Z0JBQ1AsZUFBZSxFQUFFLFNBQVM7Z0JBQzFCLFVBQVUsRUFBRSxHQUFHO2dCQUNmLEtBQUssRUFBRSxTQUFTO2dCQUNoQixRQUFRLEVBQUUsU0FBUztnQkFDbkIsWUFBWSxFQUFFLFFBQVE7Z0JBQ3RCLE9BQU8sRUFBRSxtQ0FBbUM7YUFDN0M7WUFDRCxLQUFLLEVBQUU7Z0JBQ0wsS0FBSyxFQUFFLFNBQVM7YUFDakI7U0FDRjtLQUNGO0lBQ0QsV0FBVyxFQUFFO1FBQ1gsY0FBYyxFQUFFO1lBQ2QsSUFBSSxFQUFFO2dCQUNKLEtBQUssRUFBRSxTQUFTO2dCQUNoQixjQUFjLEVBQUU7b0JBQ2QscUJBQXFCLEVBQUU7d0JBQ3JCLElBQUksRUFBRSxTQUFTO3FCQUNoQjtpQkFDRjthQUNGO1lBQ0QsSUFBSSxFQUFFO2dCQUNKLElBQUksRUFBRSxTQUFTO2FBQ2hCO1NBQ0Y7S0FDRjtJQUNELFlBQVksRUFBRTtRQUNaLGNBQWMsRUFBRTtZQUNkLEtBQUssRUFBRTtnQkFDTCxLQUFLLEVBQUUsU0FBUzthQUNqQjtZQUNELGFBQWEsRUFBRTtnQkFDYixvQkFBb0IsRUFBRTtvQkFDcEIsS0FBSyxFQUFFLE1BQU07b0JBQ2IsTUFBTSxFQUFFLE1BQU07aUJBQ2Y7YUFDRjtZQUNELGNBQWMsRUFBRTtnQkFDZCxxREFBcUQsRUFBRTtvQkFDckQsU0FBUyxFQUFFLENBQUM7aUJBQ2I7YUFDRjtTQUNGO0tBQ0Y7SUFDRCxhQUFhLEVBQUU7UUFDYixjQUFjLEVBQUU7WUFDZCxJQUFJLEVBQUU7Z0JBQ0osT0FBTyxFQUFFLFdBQVc7YUFDckI7U0FDRjtLQUNGO0lBQ0QsZ0JBQWdCLEVBQUU7UUFDaEIsY0FBYyxFQUFFO1lBQ2QsZ0JBQWdCLEVBQUU7Z0JBQ2hCLEdBQUcsRUFBRSxNQUFNO2dCQUNYLElBQUksRUFBRSxxQkFBcUI7Z0JBQzNCLEtBQUssRUFBRSxvQkFBb0I7Z0JBQzNCLFFBQVEsRUFBRSxVQUFVO2FBQ3JCO1lBQ0QsY0FBYyxFQUFFO2dCQUNkLGNBQWMsRUFBRSxRQUFRO2dCQUN4QixjQUFjLEVBQUUsVUFBVTthQUMzQjtZQUNELElBQUksRUFBRTtnQkFDSixXQUFXLEVBQUUsU0FBUzthQUN2QjtTQUNGO0tBQ0Y7Q0FDRixDQUFDIn0=